// Bootstrap以外のJavaScriptを読み込む
import '../../../public/ipallets/template/js/header.js';
import './js/index.js';
// HTMLファイルを読み込む
import './index.html';
// スタイルシートを読み込む
import './scss/style.scss';
